import React from "react"
import DeliveryOptionSkeleton from "./DeliveryOptionSkeleton/DeliveryOptionSkeleton.component"
import DeliveryOptionCompactSkeleton from "./DeliveryOptionSkeleton/DeliveryOptionCompactSkeleton.component"
import OrderMetricsSkeleton from "./OrderHistorySkeleton/OrderHistoryDesktopSkeleton/OrderMetricsSkeleton"
import OrderHistoryMobileSkeleton from "./OrderHistorySkeleton/OrderHistoryMobileSkeleton/OrderHistoryMobileSkeleton"
import TodaysOrderMobileSkeleton from "./TodaysOrdersSkeleton/TodaysOrderMobileSkeleton/TodaysOrdersMobileSkeleton"
import TodaysOrderDesktopSkeleton from "./TodaysOrdersSkeleton/TodaysOrdersDesktopSkeleton/TodaysOrderDesktopSkeleton"

type KosmoLoadingSkeletonProps = {
  isLoading?: boolean
  type?: string
  columns?: any
  rowSelection?: any
}
const KosmoLoadingSkeleton: React.FC<KosmoLoadingSkeletonProps> = (props) => {
  const getSkeletonLayout = (type: string | undefined) => {
    switch (type) {
      case "deliveryOptions":
        return <DeliveryOptionSkeleton />
      case "deliveryOptionsCompact":
        return <DeliveryOptionCompactSkeleton />
      case "orderMetricDesktop":
        return <OrderMetricsSkeleton />
      case "orderMetricMobile":
        return <OrderHistoryMobileSkeleton />
      case "todaysOrdersDesktop":
        return <TodaysOrderDesktopSkeleton />
      case "todaysOrdersMobile":
        return <TodaysOrderMobileSkeleton />
      default:
        return <></>
    }
  }

  return getSkeletonLayout(props.type)
}

export default KosmoLoadingSkeleton
